import React from 'react';

import { Button } from '~/eds/src/components/Button/Button';
import { useIntl } from 'react-intl';
import Box from '~/ui/components/Box/Box';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import Text from '~/ui/components/Text/Text';

function SummaryRow({ children, title, onChange }) {
  const intl = useIntl();

  return (
    <FlexLayout
      alignItems="center"
      justifyContent="space-between"
      space={12}
      mt="-1px"
      p={6}
      sx={{ borderBottom: 'border', borderTop: 'border' }}
    >
      <Text
        color="gray-700"
        variant="s-dense-bold"
        sx={{
          flex: '0 0 112px',
        }}
      >
        {title}
      </Text>
      <Box sx={{ flex: 'auto' }}>{children}</Box>
      <Button
        text={intl.formatMessage({
          id: 'SummaryRow.changeButton',
          defaultMessage: 'Change',
          description: 'Button text to change the summary row item',
        })}
        variant="action"
        onClick={onChange}
      />
    </FlexLayout>
  );
}

export default SummaryRow;
